import formatCents from './formatCents.js'

export default formatCents
